import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_show_checked_baggage_exclusions",
  stages: {
    affected_users: 1,
    main: 2, // Users viewing Fare with checked baggage (All airlines) in checkout steps
    show_excl_not_req_by_airline: 3,
    ddot: 4,
    mdot: 5,
    solo_travellers: 6,
    multi_travellers: 7,
    has_infant_traveller: 8,
    check_and_pay: 9
  },
  goals: {},
  defaultStage: 1
});

export const trackStages = (
  isMobile: boolean,
  isMultiTraveller: boolean,
  hasInfantTraveller: boolean,
  isCheckAndPay: boolean,
  excludedFeaturesRequiredByAirline: boolean
) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();

  if (!excludedFeaturesRequiredByAirline) utils.stages.show_excl_not_req_by_airline();
  if (isCheckAndPay) utils.stages.check_and_pay();
  if (!isMultiTraveller) utils.stages.solo_travellers();
  if (isMultiTraveller) utils.stages.multi_travellers();
  if (hasInfantTraveller) utils.stages.has_infant_traveller();
};

export default { ...utils, trackStages };
